var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "16px",
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checklist_FILL0_wght400_GRAD0_opsz48 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checklist_FILL0_wght400_GRAD0_opsz48-Copy",
    fill: "#505050",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.7275,16 L0,12.109589 L1.1025,10.9589041 L3.7275,13.6712329 L8.42625,8.76712329 L9.52875,9.94520548 L3.7275,16 Z M3.7275,7.23287671 L0,3.34246575 L1.1025,2.19178082 L3.7275,4.90410959 L8.42625,0 L9.52875,1.17808219 L3.7275,7.23287671 Z M11.55,13.9178082 L11.55,12.2739726 L21,12.2739726 L21,13.9178082 L11.55,13.9178082 Z M11.55,5.15068493 L11.55,3.50684932 L21,3.50684932 L21,5.15068493 L11.55,5.15068493 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProducts);
export default __webpack_public_path__ + "static/media/all_products.5d17d7441dcc0d4aefae5ea2445ec4e7.svg";
export { ForwardRef as ReactComponent };